import _ from "lodash";

type User = {
  firstName: string | undefined;
  lastName: string | undefined;
}

export const nameFromUser = (user: User | undefined) => `${ _.get(user, "firstName", "")} ${_.get(user, "lastName", "") }`;